<template>
  <div class="">
    <alert-message-modal></alert-message-modal>
    <Navigation></Navigation>
    <div class="content content-narrow">
      <div class="row">
        <strain></strain>
        <room></room>
        <plant-batch></plant-batch>
        <item></item>
        <package></package>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import Navigation from '@/components/Navigation';
import Strain from '@/components/boxes/Strain';
import Room from '@/components/boxes/Room';
import PlantBatch from '@/components/boxes/PlantBatch';
import Item from '@/components/boxes/Item';
import Package from '@/components/boxes/Package';
import AlertMessageModal from '@/components/AlertMessageModal';

export default {
  name: 'Dashboard',
  components: {
    Navigation,
    Strain,
    Room,
    PlantBatch,
    Item,
    Package,
    AlertMessageModal
  },
  created() {
    this.removeFile('/static/js/oneui.app.min.js', 'js');
    this.removeFile('/static/js/be_tables_datatables.min.js', 'js');
    this.loadFile('/static/js/oneui.app.min.js', 'js');  
    this.loadFile('/static/js/be_tables_datatables.min.js', 'js');  
  },
  methods: {
    ...mapActions('alert', ['success', 'error']),
  },
  beforeDestory() {
    this.removeFile('/static/js/oneui.app.min.js', 'js');
    this.removeFile('/static/js/be_tables_datatables.min.js', 'js');
  }
};
</script>
<style>
.datatables .block-content {
  overflow: auto;
}
.bg-city-light {
  background-color: #9eb89f !important;
}
.datatables table thead th,
.datatables table tbody td {
  text-align: center;
}
div.dataTables_wrapper div.dataTables_filter input {
  margin-left: 0 !important;
  display: inline-block;
  width: 100% !important;
}
.btn-block-option {
  padding-right: 0 !important;
}
.no-sorting:after {
  content: '' !important;
}
div.dataTables_wrapper div.dataTables_info {
  text-align: center !important;
  white-space: inherit;
}
div.dataTables_wrapper div.dataTables_paginate {
  text-align: center !important;
}
.pagination {
  display: block !important;
}
.pagination li {
  display: inline-block;
}
.text-break-large {
  width: 50%;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// source/components/Dashboard.vue